module.exports = __webpack_public_path__ + "static/media/SharedBlueNested.2a4402cd.svg";